import verifiedIcon from '@assets/misc/verified-icon.svg';
import { displayTime } from '@global/helpers/general';
import { Box, Typography } from '@mui/material';
import GenericFormAlert from './generic';

// eslint-disable-next-line react-refresh/only-export-components
export enum TransactionEvaluationState {
  NotInitialized = 'notInitialized',
  EvaluationRequested = 'evaluationRequested',
  DocumentSent = 'documentSent',
  EvaluationReportSent = 'evaluationReportSent'
}

const getEvaluationStatusMessage = (status: string) => {
  switch (status) {
    case TransactionEvaluationState.NotInitialized:
      return 'Evaluation has not started yet';

    case TransactionEvaluationState.EvaluationRequested:
      return 'Evaluation request received and is in progress';

    case TransactionEvaluationState.DocumentSent:
      return 'Documents have been forwarded to the evaluation partner';

    case TransactionEvaluationState.EvaluationReportSent:
      return 'Evaluation is complete and the report has been sent to Career Mosaic';

    default:
      return null;
  }
};

export default function Verified({ txnInfo }: { txnInfo: any }) {
  const evaluationStatus = import.meta.env.VITE_ENABLE_EVALUATION && txnInfo?.evaluation?.state;
  const evaluationMessage = evaluationStatus ? getEvaluationStatusMessage(evaluationStatus) : null;

  return (
    <>
      <GenericFormAlert
        title={'Congratulations!'}
        theme="light"
        icon={<img src={verifiedIcon} alt="Verified Icon" />}
        caption={
          <Box sx={{ display: 'flex', flexFlow: 'column', rowGap: '.45rem', alignItems: 'center' }}>
            <Typography variant="body2">Your verification was successfully completed on</Typography>
            <Typography variant="body1" sx={{ fontWeight: '600', color: 'primary.main' }}>
              {displayTime(txnInfo?.updatedAt, 'Do MMMM YYYY')}
            </Typography>
            {evaluationMessage && (
              <>
                <Typography
                  variant="body2"
                  sx={{ mt: 0, fontWeight: '600', maxWidth: '90%', textAlign: 'center' }}>
                  Evaluation Status:{' '}
                  <Box component="span" sx={{ fontWeight: '600', color: 'primary.main' }}>
                    {evaluationMessage}
                  </Box>
                </Typography>
              </>
            )}
          </Box>
        }
      />
    </>
  );
}
